import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AuthContext } from "./context/AuthContext";
import React from "react";
import { Loader } from "./components/Loader";
import ErrorPage from "./pages/404/ErrorPage";
import Maincomp from "./components/Maincomp/Maincomp";

const PrivateRoute = ({ children, requiredPermissions }) => {
  const { loading, user, getUserPermissions,error } = useContext(AuthContext);
  const [userPermissions, setUserPermissions] = useState(null);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        try {
          const role = await getUserPermissions(user.uid);
          setUserPermissions(role);
        } catch (error) {
          setUserPermissions([]);
        }
      }
    };

    fetchUserRole();
  }, [user, getUserPermissions]);

  if (loading || userPermissions === null) {
    return <Loader />;
  }

  if (error) {
    return <ErrorPage/>;
  }
  const hasPermission = userPermissions && userPermissions.includes(requiredPermissions);

  if (hasPermission) {
    return children; // Render the protected route component
  }
  return <Maincomp content={<ErrorPage/>}/>;
};

PrivateRoute.propTypes = {
  children: PropTypes.node,
  requiredPermissions: PropTypes.string.isRequired,
};

export default PrivateRoute;
